import { Ambiente } from '../../types';
import { ElegibilidadeWidgetAvaliacaoConfig, Params } from './elegibilidade-widget-avaliacao.types';

const configDefault: ElegibilidadeWidgetAvaliacaoConfig = {
  blocklist: [{ marca: 'idomed' }],
  blockListModalidade: ['TOTAL EAD', 'EAD', 'DIGITAL', 'FLEX', 'SEMIPRESENCIAL', 'SEMI', 'PRESENCIAL', 'AO VIVO'],
  blockListPeriodo: ['2025.2', '2025.3', '2025.4'],
  listaPeriodoModalidadeCombos: [
    { periodo: '2025.2', modalidades: ['TOTAL EAD', 'EAD', 'FLEX', 'SEMI', 'SEMIPRESENCIAL', 'PRESENCIAL', 'AO VIVO'] },
    { periodo: '2025.3', modalidades: ['TOTAL EAD', 'EAD', 'FLEX'] },
  ],
};

const configsPorAmbiente: Record<Ambiente, ElegibilidadeWidgetAvaliacaoConfig> = {
  dev: { ...configDefault },
  prd: configDefault,
  hml: configDefault,
  local: { ...configDefault },
};

export const getElegibilidadeWidgetAvaliacaoConfig = ({ ambiente }: Params): ElegibilidadeWidgetAvaliacaoConfig =>
  configsPorAmbiente[ambiente];
